import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { required, maxLength, multiEmail } from '@src/validation';
import * as actions from '@src/store/actions';
import connect from 'react-redux/es/connect/connect';
import ManagementCompanyForm from './ManagementCompanyForm/ManagementCompanyForm';

const fieldValidator = {
  name: [required, value => maxLength(value, 255)],
  contact_name: [value => maxLength(value, 255)],
  phone: [value => maxLength(value, 64)],
  email: [multiEmail, value => maxLength(value, 255)],
  fax: [value => maxLength(value, 64)],
  address_line_1: [value => maxLength(value, 255)],
  address_line_2: [value => maxLength(value, 255)],
  city: [value => maxLength(value, 255)],
  state: [value => maxLength(value, 64)],
  zip_code: [value => maxLength(value, 32)]
};
class ManagementCompanyModal extends React.Component {
  constructor(props) {
    super(props);
    const fields = {};

    Object.keys(fieldValidator).forEach(key => {
      fields[key] = {
        value:
          props.entity[key] !== undefined && props.entity[key] !== null
            ? props.entity[key]
            : '',
        visited: false,
        error: false
      };
    });

    this.state = { ...fields };
  }

  updateForm = (event, name) => {
    const inputData = {
      value: event.target.value,
      visited: true,
      error: false
    };

    for (let i = 0; i < fieldValidator[name].length; i++) {
      const validationMsg = fieldValidator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }

    this.setState({
      [name]: inputData
    });
  };

  submitHandler = e => {
    e.preventDefault();
    const formData = JSON.parse(JSON.stringify(this.state));
    const postData = {};
    let isValid = true;

    Object.keys(fieldValidator).forEach(key => {
      postData[key] = formData[key].value;
      for (let i = 0; i < fieldValidator[key].length; i++) {
        const validationMsg = fieldValidator[key][i](formData[key].value);
        formData[key].visited = true;
        if (validationMsg !== undefined) {
          formData[key].error = validationMsg;
          isValid = false;
          break;
        } else {
          formData[key].error = false;
        }
      }
    });

    this.setState({ ...formData });

    if (isValid) {
      if (
        this.props.entity !== undefined &&
        this.props.entity.id !== undefined
      ) {
        this.props.onEdit(this.props.entity.id, postData, () =>
          this.props.toggle()
        );
      } else {
        this.props.onCreate(postData, this.props.history);
      }
    }
    return false;
  };

  render = () => {
    return (
      <Modal
        isOpen={this.props.isActive}
        toggle={this.props.toggle}
        className={this.props.className}
        size={'lg'}
      >
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
        >
          <ModalHeader toggle={this.props.toggle}>
            {this.props.entity.id !== undefined
              ? 'Edit Management Company'
              : 'Create New Management Company'}
          </ModalHeader>
          <div className={'position-relative'}>
            <ModalBody className={'p-4'}>
              <ManagementCompanyForm
                state={this.state}
                updateForm={this.updateForm}
              />
            </ModalBody>
            <ModalFooter className={'py-4'}>
              <Button color="primary" className={'btn px-3'} type={'submit'}>
                Save
              </Button>
            </ModalFooter>
          </div>
        </form>
      </Modal>
    );
  };
}

const mapStateToProps = state => {
  return {
    loading: state.managementCompany.loading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onCreate: (postData, history) =>
      dispatch(actions.createManagementCompany(postData, history)),
    onEdit: (entityId, postData, callback) =>
      dispatch(actions.editManagementCompany(entityId, postData, callback))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManagementCompanyModal);
